import { useLayoutEffect } from 'react';

export const useOnWindowResize = (callback: () => any) => {
  useLayoutEffect(() => {
    const EVENT_TYPE = 'resize';

    window.addEventListener(EVENT_TYPE, callback);

    return () => {
      window.removeEventListener(EVENT_TYPE, callback);
    };
  }, [callback]);
};
